import { z } from 'zod';

// Date and DateTime schemas for common use throughout the application
// These validate ISO date strings but keep them as strings (no coercion to Date objects)
// API responses return strings, and code wraps in new Date() when Date operations are needed
export const Zdate = z
  .string()
  .refine((val) => !isNaN(Date.parse(val)), {
    message: 'Invalid date format',
  })
  .describe('Date in ISO format (YYYY-MM-DD)');

export const ZdateTime = z
  .string()
  .refine((val) => !isNaN(Date.parse(val)), {
    message: 'Invalid datetime format',
  })
  .describe('Date and time in ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)');

// ICAO type (4-letter airport code)
export const ZICAO = z
  .string()
  .length(4)
  .regex(/^[A-Z]+$/)
  .brand('ZICAO')
  .describe(
    'ICAO (International Civil Aviation Organization) airport code - a 4-letter code identifying airports worldwide (e.g., EGLL for London Heathrow, KJFK for New York JFK)',
  );

// IATA type (3-letter airport code)
export const ZIATA = z
  .string()
  .length(3)
  .regex(/^[A-Z]+$/)
  .brand('ZIATA')
  .describe(
    'IATA (International Air Transport Association) airport code - a 3-letter code identifying commercial airports (e.g., LHR for London Heathrow, JFK for New York JFK)',
  );
